export enum DecisionStrategyUpdatesActions {
  GetUpdatesData = 'decisionStrategyUpdates/getUpdatesData',
  GetUpdatesDataSuccess = 'decisionStrategyUpdates/getUpdatesDataSuccess',
  GetUpdatesDataFailure = 'decisionStrategyUpdates/getUpdatesDataFailure',
  SetSortingType = 'decisionStrategyUpdates/setSortingType',
  ResetState = 'decisionStrategyUpdates/resetState',
}
